module.exports = __webpack_public_path__ + "img/t1.64a2e944.png";